export default function PointerArrow({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.7991 10.1127C13.237 11.6748 10.7044 11.6748 9.14228 10.1127L0.00014505 0.970545L11.9707 0.970537L23.9413 0.970543L14.7991 10.1127Z"
        fill="currentColor"
      />
    </svg>
  )
}
